module.exports = __webpack_public_path__ + "img/unfold-logo.feddb51e.svg";